export default "__VITE_ASSET__t4b1FmaT__"